import { ReactComponent as Violin } from "./lullaby-violin.svg";
import { ReactComponent as Noise } from "./lullaby-noise.svg";
import { ReactComponent as Microphone } from "./microphone-outlined.svg";
import { ReactComponent as Car } from "./lullaby-car.svg";
import { ReactComponent as Clock } from "./lullaby-clock.svg";
import { ReactComponent as Crickets } from "./lullaby-crickets.svg";
import { ReactComponent as Fan } from "./lullaby-fan.svg";
import { ReactComponent as Fireplace } from "./lullaby-fire.svg";
import { ReactComponent as Forest } from "./lullaby-forest.svg";
import { ReactComponent as Heartbeat } from "./lullaby-heartbeat.svg";
import { ReactComponent as Plane } from "./lullaby-plane.svg";
import { ReactComponent as Rain } from "./lullaby-rain.svg";
import { ReactComponent as Rainforest } from "./lullaby-rainforest.svg";
import { ReactComponent as River } from "./lullaby-river.svg";
import { ReactComponent as Sea } from "./lullaby-sea.svg";
import { ReactComponent as Shower } from "./lullaby-shower.svg";
import { ReactComponent as Storm } from "./lullaby-storm.svg";
import { ReactComponent as Train } from "./lullaby-train.svg";
import { ReactComponent as TwinkleTwinkle } from "./lullaby-twinkle-twinkle.svg";
import { ReactComponent as VacuumCleaner } from "./lullaby-vacuum-cleaner.svg";
import { ReactComponent as WarmKitty } from "./lullaby-warmkitty.svg";
import { ReactComponent as WashingMachine } from "./lullaby-washing-machine.svg";
import { ReactComponent as Whales } from "./lullaby-whales.svg";

const icons = {
  brahmss_lullaby: Violin,
  brown_noise: Noise,
  car: Car,
  clock: Clock,
  crickets: Crickets,
  fan: Fan,
  fireplace: Fireplace,
  forest: Forest,
  heartbeat: Heartbeat,
  pink_noise: Noise,
  plane: Plane,
  rain: Rain,
  rainforest: Rainforest,
  river: River,
  sea: Sea,
  shower: Shower,
  storm: Storm,
  train: Train,
  twinkle_twinkle: TwinkleTwinkle,
  vacuum_cleaner: VacuumCleaner,
  warm_kitty: WarmKitty,
  washing_machine: WashingMachine,
  whales: Whales,
  white_noise: Noise,
  record: Microphone
};

export default function getLullabyIcon(lullabyIdentifier) {
  return icons[lullabyIdentifier] || icons.record;
}
